import React from 'react';
import './RowStatusIndicator.css';

const RowStatusIndicator = ({ product, status }) => {
  const getValue = (field) => {
    const val = product[field];

    // ✅ Special handling for numberOutput fields (e.g., "10/20")
    if (field === "numberOutput" && typeof val === "string" && val.includes("/")) {
      const [received] = val.split("/").map(Number);
      return received > 0;
    }

    return val !== null && val !== undefined && val !== '' &&
      !(Array.isArray(val) && val.length === 0);
  };

  // ✅ Special rule for InventoryStatus: if fabrication done but numberOutput not complete, return "Stock Incoming"
  const isInventoryStatus = Object.keys(status).includes("In Fabrication") && Object.keys(status).includes("Stock Arrived");

  const isFabricationCompleted = () => {
    const statusKeys = Object.keys(status);
    const fabricationIndex = statusKeys.indexOf("In Fabrication");
    if (fabricationIndex === -1) return false;

    const fieldsTillFabrication = statusKeys
      .slice(0, fabricationIndex + 1)
      .flatMap(stage => status[stage]);

    return fieldsTillFabrication.every(getValue);
  };

  const isNumberOutputComplete = () => {
    const numberOutput = product?.numberOutput;
    if (typeof numberOutput === "string" && numberOutput.includes("/")) {
      const [received, total] = numberOutput.split("/").map(Number);
      return received >= total;
    }
    return false;
  };

  const getDetectedStage = () => {
    const statusKeys = Object.keys(status);

    // ✅ Custom intermediate logic for InventoryStatus
    if (isInventoryStatus && isFabricationCompleted() && !isNumberOutputComplete()) {
      return "Stock Incoming";
    }

    for (let i = 0; i < statusKeys.length; i++) {
      const stage = statusKeys[i];
      const requiredFields = statusKeys
        .slice(0, i + 1)
        .flatMap(stageName => status[stageName]);

      const allFilled = requiredFields.every(getValue);

      if (!allFilled) {
        return i === 0 ? "Not Started" : statusKeys[i - 1];
      }
    }

    return statusKeys[statusKeys.length - 1]; 
  };

  const currentStage = getDetectedStage();

  return (
    <div className={`status-chip status-${currentStage.replace(/\s+/g, '-').toLowerCase()}`}>
      {currentStage}
    </div>
  );
};

export default RowStatusIndicator;
